// src/Question.js
// [แก้ไข] ลบปุ่ม "กลับ" และ handleBackToLeaderboard ออก

import React, { useState, useEffect, useCallback } from 'react';
import { Table, Spin, Alert } from 'antd';
import { useNavigate } from 'react-router-dom';
import { db } from './Firebase';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore'; 

import './Question.css'; 

function Question() {
  const navigate = useNavigate();
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const [title, setTitle] = useState('คำตอบผู้เข้าแข่งขัน');

  const fetchQuestionData = useCallback(async (isBackgroundUpdate = false) => {
    if (!db) return;
    
    if (!isBackgroundUpdate) {
      setLoading(true);
    }
    
    try {
      // --- 1. หาชื่อห้อง (จาก .../Admin/Room) ---
      const roomConfigRef = doc(db, "Competition-Training", "nathadaj", "Admin", "Room");
      const roomConfigSnap = await getDoc(roomConfigRef);

      if (!roomConfigSnap.exists()) {
        throw new Error("ไม่พบเอกสารตั้งค่าห้อง (Admin/Room)");
      }
      
      const roomName = roomConfigSnap.data().Meeting; 
      if (!roomName) {
        throw new Error("ไม่พบชื่อห้องในเอกสารตั้งค่า (field 'Meeting')");
      }

      // --- 2. ดึง Title (เหมือนใน Leaderboard) ---
      if (!isBackgroundUpdate) {
        try {
          const roomInfoRef = doc(db, "Competition-Training", "nathadaj", roomName, "Admin");
          const roomInfoSnap = await getDoc(roomInfoRef);
          if (roomInfoSnap.exists() && roomInfoSnap.data().description) {
            setTitle(roomInfoSnap.data().description); 
          }
        } catch (titleError) {
           console.warn("Could not fetch title:", titleError.message);
        }
      }

      // --- 3. ดึงข้อมูลผู้ใช้ และคำตอบ 1-20 ---
      const roomUsersCollectionRef = collection(db, "Competition-Training", "nathadaj", roomName);
      const roomUsersSnapshot = await getDocs(roomUsersCollectionRef);

      if (roomUsersSnapshot.empty) {
         throw new Error(`ไม่พบผู้ใช้ในห้อง ${roomName}`);
      }

      const fetchedUsers = [];
      
      roomUsersSnapshot.forEach((userDoc) => {
          const username = userDoc.id;
          const data = userDoc.data();
          
          if (data.hide) {
              return; 
          }

          const fullName = (data.name && data.surname) 
              ? `${data.name} ${data.surname}` 
              : data.name || data.surname || username;
          
          const answers = {};
          for (let i = 1; i <= 20; i++) {
              const answerValue = data[`answer-${i}`];
              answers[i] = (answerValue === undefined || answerValue === null) ? '-' : String(answerValue);
          }

          fetchedUsers.push({
              id: username,
              name: fullName, 
              answers: answers, 
          });
      });

      setUsersData(fetchedUsers);
      setError(null); 

    } catch (err) {
      if (err.code === 'permission-denied') {
        setError("Permission Denied: ตรวจสอบ Firestore Security Rules");
      } else {
        setError(`เกิดข้อผิดพลาด: ${err.message}`);
      }
    } finally {
      if (!isBackgroundUpdate) {
        setLoading(false);
      }
    }
  }, [db]); 

  useEffect(() => {
    if (db) {
      fetchQuestionData(false); 
      const intervalId = setInterval(() => {
        fetchQuestionData(true); 
      }, 5000); 
      return () => {
        clearInterval(intervalId); 
      };
    }
  }, [db, fetchQuestionData]);

  // --- [ลบ] ฟังก์ชันสำหรับปุ่มกลับ (handleBackToLeaderboard) ---

  // --- สร้าง Columns สำหรับตาราง ---
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      fixed: 'left', 
      width: 180, 
      className: 'name-cell-question',
    },
  ];

  for (let i = 1; i <= 20; i++) {
    columns.push({
      title: `ข้อ ${i}`, 
      dataIndex: 'answers',
      key: `ans-${i}`,
      align: 'center',
      width: 80, 
      render: (answers) => answers[i], 
    });
  }
  // ----------------------------------------

  return (
    <div className="question-container"> 
      <div className="question-header">
        <div className="logo-container">
          <img 
            src="/Wisdom-Logo.png" 
            alt="Wisdom Logo" 
            className="logo-image1"
            onClick={() => fetchQuestionData(false)} 
          />
        </div>
        
        <h1 className="question-title">
          {title}
        </h1>

        {/* --- [ลบ] ปุ่มกลับ และเพิ่ม Spacer แทน --- */}
        <div className="button-group" style={{ visibility: 'hidden' }}>
          {/* This is a spacer to balance the header */}
        </div>
      </div>

      {error && (
        <Alert
          message="ข้อผิดพลาด"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: '20px' }}
        />
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
          <p>กำลังโหลดข้อมูลคำตอบ...</p>
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={usersData}
          rowKey="id"
          pagination={false}
          bordered
          scroll={{ x: 1800 }} 
          locale={{ emptyText: 'ไม่มีข้อมูล' }}
          className="question-table"
        />
      )}
    </div>
  );
}

export default Question;